<template>
  <popup ref="popup" :show="show" :title="title" @close="close">
    <template slot-scope="props">
      <single-option
        v-for="item in options"
        :key="item.key"
        :label="item.label"
        :value="item.value"
        :checked="checked ? checked : item.checked"
        :close="props.close"
        @change="change"
      />
    </template>
  </popup>
</template>

<script>
import { mapState } from 'vuex'
import popup from '../index.vue'
import singleOption from './singleOption.vue'
import { showRtboStore } from '@/common/utils/BizUtils'

export default {
  components: {
    popup,
    singleOption,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    checkedValue: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      /**
       * [{
       *    label: "",
       *    value: ""
       * }]
       */
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return { checked: '' }
  },
  computed: {
    ...mapState('store', {
      valuesSortType: state => state.filterValue.sortType || 0,
    }),
  },
  watch: {
    checkedValue: {
      immediate: true,
      deep: true,
      handler(val) {
        this.checked = val
      },
    },
    options: {
      deep: true,
      handler(val) {
        if (showRtboStore()) {
          this.checked = this.valuesSortType
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    change(value) {
      this.checked = value
      this.$emit('submit', this.checked)
    },
  },
}
</script>

<style lang="scss" scoped></style>
